import { PRODUCTS } from "../data/products";
import ScrollReveal from "./ScrollReveal";

/**
 * Plain `<a href="#id">`, not a router `<Link>` — a same-document fragment
 * navigation, so the browser's native hash-scroll fires immediately, well
 * under the AC's 500ms budget. Note this isn't fully isolated from
 * App.tsx's cross-page hash-scroll effect: a fragment-only anchor click
 * still fires `popstate`, which updates `location.hash` and re-runs that
 * effect too. Harmless here — the target is already mounted, so its poll
 * resolves on the first check and calls the same `scrollIntoView()` the
 * browser just did — but it means both mechanisms run on every click here,
 * not just the native one.
 */
export default function ProductGrid() {
  return (
    <div className="grid gap-6 sm:grid-cols-2">
      {PRODUCTS.map((product, i) => (
        <ScrollReveal key={product.id} delay={i * 0.08}>
          <a
            href={`#${product.id}`}
            className="block h-full rounded-2xl bg-white p-6 shadow-sm ring-1 ring-ocean-900/5 transition-colors hover:ring-teal-400/40"
          >
            <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-teal-400/15 text-teal-500">
              <product.icon className="h-5 w-5" strokeWidth={1.5} />
            </div>
            <h3 className="mt-4 font-display font-semibold text-ocean-950">{product.name}</h3>
            {product.internalOnly && product.audienceNote && (
              <span className="mt-1.5 inline-block rounded-full bg-ocean-900/5 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-ocean-800/60">
                {product.audienceNote}
              </span>
            )}
            <p className="mt-2 text-sm leading-relaxed text-ocean-800/70">{product.summary}</p>
          </a>
        </ScrollReveal>
      ))}
    </div>
  );
}
